// @flow
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';

import CommonPage from 'app/common/templates/CommonPage';
import Children from 'app/components/Children';
import { getIsStudent } from 'app/selectors/user';
import { AddChildButton } from 'app/components/AddChild';


type Props = {
  params: {
    date?: string
  }
}

const ChildrenPage = ({ ...routerProps }: Props) => {
  const { t } = useTranslation('children');

  const { params: { date = moment().format('YYYY-MM-DD') } } = routerProps;
  const headerSuffix = useMemo(() => ` — ${moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')}`, [date]);

  const isStudent = useSelector(getIsStudent);
  const header = isStudent ? t('title_solo') : t('title');

  return (
    <CommonPage
      header={header}
      headerSuffix={headerSuffix}
      rightSideNode={<AddChildButton />}
    >
      <Children {...routerProps} />
    </CommonPage>
  );
};

export default ChildrenPage;
